import { lazy } from "react";

export const UploadCreationTool = lazy(
    () => import("@mediaspace/features/add-to-category/creation-tools/upload/UploadCreationTool")
);

export const UploadCreationToolButton = lazy(
    () => import("@mediaspace/features/add-to-category/creation-tools/upload/UploadCreationToolButton")
);

export const RecorderCreationTool = lazy(
    () => import("@mediaspace/features/add-to-category/creation-tools/recorder/RecorderCreationTool")
);

export const RecorderCreationToolButton = lazy(
    () => import("@mediaspace/features/add-to-category/creation-tools/recorder/RecorderCreationToolButton")
);

export const YouTubeCreationTool = lazy(
    () => import("@mediaspace/features/add-to-category/creation-tools/youtube/YoutubeCreationTool")
);

export const YouTubeCreationToolButton = lazy(
    () => import("@mediaspace/features/add-to-category/creation-tools/youtube/YoutubeCreationToolButton")
);

export { AddToCategoryButton, CategoryNotificationChecker } from "@mediaspace/features/add-to-category";
